import { configureStore } from '@reduxjs/toolkit'
import appReducer from './reducer'
import languageReducer from "../../src/Redux/languageSlice";

export default configureStore({
  reducer: {
    user:appReducer,
    language: languageReducer,

  },
})